import React from "react";
import {Button, ButtonGroup, Form, Modal, ModalBody, ModalHeader} from "reactstrap";
import {ModalActions} from "../../Store/Modal/Slice";
import {FORGOT_PASSWORD_MODAL} from "../../Store/Modal/Types";
import {useDispatch, useSelector} from "react-redux";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import InputComponent from "../Shared/Inputs/InputComponent";
import {AuthActions} from "../../Store/Auth/Slice";
import {RootState} from "../../Store/Reducers";
import {LoadingTypes} from "../../Models/LoadingType";
import {emailRegexPattern} from "../../Utils/Utils";

const ForgotPasswordModalComponent = () => {

  const dispatch = useDispatch();

  const {LoadingReducer: {loadingForgotPassword: {status: {e}}}} = useSelector((state: RootState) => state);

  const forgotPasswordForm = useForm<{ email: string }>();

  const onSubmit: SubmitHandler<{ email: string }> = (data: { email: string }) => {

    dispatch(AuthActions.forgotPassword(data));
  };

  const closeForgotPasswordModal = () => {
    dispatch(ModalActions.closeModal({modal: FORGOT_PASSWORD_MODAL}));
  };

  return (
    <Modal size="sm" isOpen>
      <ModalHeader>Olvide mi contraseña</ModalHeader>
      <ModalBody>
        <FormProvider {...forgotPasswordForm} >
          <Form>
            <InputComponent label="INGRESE EL CORREO" pattern={emailRegexPattern} required name="email"
                            className="form-control form-control-sm"/>
          </Form>
        </FormProvider>
        <div className="text-right">
          <ButtonGroup>
            <Button size="sm" outline color="danger" onClick={closeForgotPasswordModal}>Cerrar</Button>
            <Button size="sm" disabled={e === LoadingTypes.PENDING} outline color="success"
                    onClick={forgotPasswordForm.handleSubmit(onSubmit)}>
              {e === LoadingTypes.PENDING &&
              <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"/>
              }
              Enviar
            </Button>
          </ButtonGroup>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ForgotPasswordModalComponent;
